import type { CartPhoto, DP2Crop, PhotoCrop } from 'types/photo_types';
import type { PhotoUpload } from 'domains/photos';
import { round } from 'lodash';

/**
 * @deprecated
 *
 * Can be removed when wall preview & arrangement preview image generation
 * has been migrated to the order-api endpoint
 */
export function buildCartCropData(
  crop: Required<PhotoCrop>,
  photo: PhotoUpload,
  nodeId: number
): CartPhoto {
  const dp2Crops = constructDP2CropData(crop);

  return {
    ordering_upload_id: photo.id,
    photo_url: photo.ink_url,
    original_filename: photo.original_filename,
    filter_applied: crop.filter === 'original' ? '' : crop.filter,
    degrees_rotated: crop.rotation,
    node_id: nodeId,
    ...dp2Crops,
  };
}

type DeconstructCropParam = Omit<
  CartPhoto,
  'photo_url' | 'original_filename' | 'ordering_upload_id' | 'node_id'
>;

/**
 * @deprecated
 *
 * Can be removed when wall preview & arrangement preview image generation
 * has been migrated to the order-api endpoint
 */
export function deconstructCropData(crop: DeconstructCropParam): Required<PhotoCrop> {
  const { degrees_rotated: rotation, crop_height, crop_width, crop_x, crop_y, xywhz } = crop;

  const [, , w, h, z] = xywhz.split(',').map((v) => parseFloat(v));

  const cropH = crop_height / 100;
  const cropW = crop_width / 100;
  const cropX = crop_x / 100;
  const cropY = crop_y / 100;

  const filter = crop.filter_applied === '' ? 'original' : crop.filter_applied;

  const zoom = z / 100 + 1;

  const originalH = Math.ceil(h / cropH);
  const originalW = Math.ceil(w / cropW);

  return {
    rotation,
    filter,
    zoom,
    originalH,
    originalW,
    cropH,
    cropW,
    cropX,
    cropY,
  };
}

/**
 * @deprecated
 */
function constructDP2CropData(crop: Required<PhotoCrop>): DP2Crop {
  const { cropH, cropW, cropX, cropY, originalH, originalW, zoom } = crop;

  // Get the ratio that has been cropped _out_, in both directions
  const halfCropW = round((1 - cropW) / 2, 6);
  const halfCropH = round((1 - cropH) / 2, 6);

  // Build the xywhz value
  // Crop points are saved as % away from the center, so we subtract from 0.5 to get movement from left edge
  const xywhz = [
    round((halfCropW - (0.5 - cropX)) * originalW, 6),
    round((halfCropH - (0.5 - cropY)) * originalH, 6),
    round(cropW * originalW, 6),
    round(cropH * originalH, 6),
    round((zoom - 1) * 100, 6),
  ];

  return {
    crop_height: round(cropH * 100, 6),
    crop_width: round(cropW * 100, 6),
    crop_x: round(cropX * 100, 6),
    crop_y: round(cropY * 100, 6),
    xywhz: xywhz.join(','),
  };
}
